module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"kpiBeforeTitle":"Vorher","kpiAfterTitle":"Nachher","kpiAreaLabel":"Energiebezugsfläche","kpiRhLabel":"Nutzenergie Raumwärme","kpiDhwDemandLabel":"Nutzenergie Warmwasser","kpiHeatingPowerLabel":"Heizleistung","kpiElDemandLabel":"Strombedarf","kpiElProductionLabel":"Stromproduktion","kpiElOwnUseLabel":"Stromeigenverbrauch"}}')
  delete Component.options._Ctor
}
